//tslint:disable
import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import {
  TGetChatsNotificationsMicrofrontendModel,
  IGetChatsNotificationsMicrofrontendRequest,
  TGetChatsNotificationsMicrofrontendResponse,
  IMappers,
} from './types';

const defaultConfig = {
  apiType: 'public',
  assertStatusCodes: [200],
  method: 'GET',
  microserviceName: 'chats-notifications-micro-frontend',
  pathApi: '/v1/get-chats-notifications-microfrontend/',
  requestType: 'json',
  responseType: 'json',
} as TGetChatsNotificationsMicrofrontendModel;

function createGetChatsNotificationsMicrofrontendModel(
  parameters: IGetChatsNotificationsMicrofrontendRequest,
): TGetChatsNotificationsMicrofrontendModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetChatsNotificationsMicrofrontendOptions<TResponse200> {
  httpApi: IHttpApi;
  parameters: IGetChatsNotificationsMicrofrontendRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
}

async function fetchGetChatsNotificationsMicrofrontend<TResponse200>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetChatsNotificationsMicrofrontendOptions<TResponse200>): Promise<
  TResponse200 | TGetChatsNotificationsMicrofrontendResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createGetChatsNotificationsMicrofrontendModel(parameters),
    config,
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response);
    }
  }

  return { response, statusCode } as TGetChatsNotificationsMicrofrontendResponse;
}
export { defaultConfig, createGetChatsNotificationsMicrofrontendModel, fetchGetChatsNotificationsMicrofrontend };
